<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div id="page-accordion" [formGroup]="formGroupCustomer">
      <!--Dati cliente-->
      <div class="card" [ngClass]="active_table === 'customer' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('customer')">
          <h4 class="mb-0">{{ "CUSTOMER" | translate }}</h4>
        </div>
        <section class="card-body" *ngIf="customer && active_table === 'customer'">
          <div class="row">
            <div class="col-lg-2 col-12">
              <app-form-customer-logo-upload [customer]="customer" (change)="logoBase64 = $event"></app-form-customer-logo-upload>
            </div>
            <div class="row col-lg-10 col-12">
              <div class="form-group col-12">
                <label for="name">{{ "COMPANY" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="name" class="form-control {{ fieldHasErrors('name') ? 'is-invalid' : '' }}" formControlName="name" />
                <div class="invalid-feedback" *ngIf="formGroupCustomer.controls?.name?.errors?.required">{{ "ERRORS.FIELD_COMPANY" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupCustomer.controls?.name?.errors?.minLength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupCustomer.controls?.name?.errors?.maxLength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="subject_type">{{ "MENU.CUSTOMERS_TYPE_SINGULAR" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="subject_type"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="subject_type"
                  [multiple]="false"
                  [searchable]="false"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="subjectTypeList" (change)="changeSubjectType()"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroupCustomer.controls.subject_type.errors?.required">{{ "ERRORS.FIELD_SUBJECT_TYPE" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="country"
                  bindLabel="name"
                  bindValue="code"
                  formControlName="country"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="nationsWithCodes"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroupCustomer.controls.bank.errors?.required">{{ "ERRORS.FIELD_BANK" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="email">{{ "EMAIL" | translate }}</label>
                <input type="text" id="email" class="form-control" formControlName="email" [ngClass]="{'is-invalid': formGroupCustomer.controls.email.errors!==null}" />
                <div class="invalid-feedback" *ngIf="formGroupCustomer.controls.email.errors!==null">{{ "ERRORS.INSERT_VALID_EMAIL" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="pec">{{ "PEC" | translate }}</label>
                <input type="text" id="pec" class="form-control {{ fieldHasErrors('pec') ? 'is-invalid' : '' }}" formControlName="pec" />
                <div class="invalid-feedback" *ngIf="formGroupCustomer.controls.pec.errors!==null">{{ "ERRORS.INSERT_VALID_EMAIL" | translate }}</div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- Fatturazione -->
      <div class="card" [ngClass]="active_table === 'invoice' ? 'active pb-0' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('invoice')">
          <h4 class="mb-0">{{ "CUSTOMERS_INVOICE_DATA" | translate }}</h4>
        </div>
        <section [ngClass]="active_table === 'invoice' ? 'card-body pb-0' : ''" class="row">
          <div *ngFor="let item of fieldsInvoice" class="form-group col-12" [ngClass]="'col-lg-'+(item.col_lg||6)">
            <label [for]="item.key">{{ item.key.toUpperCase() | translate }}<sup *ngIf="item.validators?.required" class="text-danger">*</sup></label>
            <ng-container [ngSwitch]="item.type">
              <ng-select *ngSwitchCase="'select'" [id]="item.key" [formControlName]="item.key" [searchable]="item.searchable || true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true"
                         [ngClass]="{'is-invalid': fieldHasErrors(item.key)}">
                <ng-option *ngFor="let element of (item.values || [])" [value]="element.value">{{ element.label | translate }}</ng-option>
              </ng-select>
              <input *ngSwitchCase="'date'" type="date" [id]="item.key" class="form-control" [formControlName]="item.key" [ngClass]="{'is-invalid': fieldHasErrors(item.key)}" />
              <input *ngSwitchDefault [type]="item.type" [id]="item.key" class="form-control" [formControlName]="item.key" [maxlength]="item.max" [ngClass]="{'is-invalid': fieldHasErrors(item.key)}"
                     [placeholder]="item.placeholder || ''" />
            </ng-container>
            <ng-container *ngIf="item.validators">
              <div class="invalid-feedback" *ngIf="formGroupCustomer.controls[item.key]?.errors?.required">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroupCustomer.controls[item.key]?.errors?.minlength">{{ "MIN" | translate }} {{ item.validators.minLength }} {{ "CHARACTERS" | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroupCustomer.controls[item.key]?.errors?.maxlength">{{ "MAX" | translate }} {{ item.validators.maxLength }} {{ "CHARACTERS" | translate }}</div>
            </ng-container>
          </div>
        </section>
      </div>

      <!--Sedi cliente-->
      <div class="card" [ngClass]="active_table === 'site' ? 'active pb-0' : ''">
        <div class="card-title px-2 mb-0 d-flex" (click)="changeTab('site')">
          <div class="col-6 pl-0">
            <h4 class="mb-0">{{ "MENU.CUSTOMERS_LOCATION" | translate }}</h4>
          </div>
          <div class="col-6" ngClass.sm="d-none" ngClass.md="d-none" *ngIf="active_table === 'site' && addressesList && addressesList.length > 0">
            <h4 class="mb-0" *ngIf="!isEditModeSite">{{ "TITLES.ADD_SITE" | translate }}</h4>
            <h4 class="mb-0" *ngIf="isEditModeSite">{{ "EDIT_SITE" | translate }}</h4>
          </div>
        </div>
        <section [ngClass]="active_table === 'site' ? 'card-body pb-0' : ''" class="row">
          <div class="col-lg-6 col-12 mt-lg-3 mt-xl-0 px-0" [ngClass.xl]="'border-right'" *ngIf="addressesList && addressesList.length > 0">
            <div class="d-flex p-1 border-bottom">
              <div class="flex-basis-30 font-weight-bold" [ngClass.sm]="'flex-basis-100'">
                {{ "LABEL" | translate }}
              </div>
              <div class="flex-basis-40 font-weight-bold" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                {{ "ADDRESS" | translate }}
              </div>
              <div class="flex-basis-20 font-weight-bold" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                {{ "CITY" | translate }}
              </div>
              <div class="flex-basis-10 font-weight-bold" *ngIf="!isEditModeSite" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                {{ "ACTIONS" | translate }}
              </div>
            </div>
            <div *ngFor="let site of addressesList; let i = index" class="py-1 px-1 border-bottom d-lg-flex align-items-lg-center"
                 [ngClass]="selectedEditSite && site.id === selectedEditSite.id ?
            'bg-primary text-white' : null">
              <div class="flex-basis-30" [ngClass.sm]="'flex-basis-100'">{{ site.label }}</div>
              <div class="flex-basis-40" [ngClass.sm]="'flex-basis-100 my-1'">{{ site.street }}</div>
              <div class="flex-basis-20" [ngClass.sm]="'flex-basis-100'">{{ site.city || site.external_city }}</div>
              <div class="flex-basis-10" *ngIf="!isEditModeSite" [ngClass.sm]="'flex-basis-100 d-flex justify-content-end'" [ngClass.md]="'flex-basis-100 d-flex justify-content-end'">
                <button class="bg-transparent border-0 text-secondary pl-0 pr-1" (click)="enterEditModeSite(site)" has_capability="edit_customer_address">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteSite(site)" class="bg-transparent border-0 text-danger remove-item" has_capability="delete_customer_address">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="{{ !addressesList || addressesList.length < 1 ? 'col-12' : 'col-lg-6 col-12' }}" has_capability="create_customer_address">
            <form class="row" [formGroup]="formGroupSite">
              <div class="col-12 my-1" ngClass.xl="d-none" ngClass.lg="d-none">
                <h4 class="mb-0" *ngIf="!isEditModeSite">{{ "TITLES.ADD_SITE" | translate }}</h4>
                <h4 class="mb-0" *ngIf="isEditModeSite">{{ "EDIT_SITE" | translate }}</h4>
              </div>
              <div class="form-group {{ !formGroupSite.value.external ? 'col-lg-4 ' : 'col-lg-6' }} col-12">
                <label for="label">{{ "LABEL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="label" class="form-control {{ fieldHasErrors('label') ? 'is-invalid' : '' }}" formControlName="label" />
                <div class="invalid-feedback" *ngIf="formGroupSite.controls.label.errors?.required">{{ "ERRORS.INSERT_LABEL" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls?.description?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls?.description?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="col-lg-6 col-12 form-group" *ngIf="formGroupSite.value.external">
                <label for="label">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select [items]="nationsWithCodes" bindLabel="name" bindValue="code" [clearable]="false" formControlName="country" [ngClass]="fieldHasErrors('country') ? 'is-invalid' : ''"></ng-select>
              </div>
              <div class="form-group {{ !formGroupSite.value.external ? 'col-lg-4 ' : null }} col-12">
                <label for="street">{{ "ADDRESS" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="street" class="form-control {{ fieldHasErrors('street') ? 'is-invalid' : '' }}" formControlName="street" />
                <div class="invalid-feedback" *ngIf="formGroupSite.controls.street.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls?.description?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls?.description?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12" *ngIf="!formGroupSite.value.external">
                <label for="zipcode">{{ "ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="zipcode" class="form-control {{ fieldHasErrors('zipcode') ? 'is-invalid' : '' }}" formControlName="zipcode" maxlength="5" />
                <div class="invalid-feedback" *ngIf="formGroupSite.controls.zipcode.errors?.required">{{ "ERRORS.INSERT_ZIPCODE" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls?.description?.errors?.minlength">{{ "MIN" | translate }} 4 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls?.description?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12" *ngIf="!formGroupSite.value.external">
                <label for="city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  formControlName="city"
                  id="city"
                  bindLabel="nice_name"
                  bindValue="id"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  class="{{ fieldHasErrors('city') ? 'is-invalid' : '' }}"
                  [items]="_citiesService.list"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="setAutoProvince()"
                >
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls.city.errors?.required">{{ "ERRORS.INSERT_ONE_CITY" | translate }}</div>
              </div>
              <div class="form-group col-12" *ngIf="formGroupSite.value.external">
                <label for="external_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                <input formControlName="external_city" id="external_city" class="form-control" [ngClass]="fieldHasErrors('external_city') ? 'is-invalid' : ''" />
                <div class="invalid-feedback" *ngIf="formGroupSite.controls.external_city.errors?.required">{{ "ERRORS.INSERT_ONE_CITY" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12" *ngIf="!formGroupSite.value.external">
                <label for="province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  formControlName="province"
                  id="province"
                  bindLabel="nice_name"
                  bindValue="id"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  class="{{ fieldHasErrors('province') ? 'is-invalid' : '' }}"
                  [items]="_citiesService.list"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                >
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroupSite.controls.province.errors?.required">{{ "ERRORS.INSERT_PROVINCE" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12" *ngIf="!formGroupSite.value.external">
                <div class="d-flex justify-content-between align-items-center" [ngbTooltip]="'KM_EXPLICATION_CALCULATE' | translate">
                  <label for="km">{{ "ADDRESS_DISTANCE" | translate }}</label>
                  <i class="mb-025" [data-feather]="'info'" size="14"></i>
                </div>
                <input type="number" id="km" placeholder="100" class="form-control {{ fieldHasErrors('km') ? 'is-invalid' : '' }}" formControlName="km" />
                <div class="invalid-feedback" *ngIf="formGroupSite.controls.km.errors?.required">{{ "ERRORS.INSERT_KM" | translate }}</div>
              </div>
              <div class="form-group col-md-4 col-12 d-flex align-items-center">
                <small class="mr-1">{{ "EXTERNAL_SITE_QUESTION" | translate }}</small>
                <div class="custom-control custom-control-primary custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitch10" formControlName="external" (change)="manageExternalSite()" />
                  <label class="custom-control-label" for="customSwitch10"> </label>
                </div>
              </div>
              <div class="form-group col-md-8 col-12 d-flex align-items-end">
                <div class="d-flex align-items-center w-fit mr-0 ml-auto">
                  <small class="mr-1">{{ "HEAD_OFFICE_QUESTION" | translate }}</small>
                  <div class="custom-control custom-control-primary custom-switch">
                    <input type="checkbox" class="custom-control-input" id="customSwitch11" formControlName="head_office" />
                    <label class="custom-control-label" for="customSwitch11"> </label>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-end mt-sm-1 mt-md-1">
                <button class="btn btn-outline-primary mr-1" type="button" (click)="resetSiteForm()">{{ "ALERT.BTN_CANCEL" | translate }}</button>
                <button class="btn btn-primary" type="button" (click)="addSite()" *ngIf="!selectedEditSite">{{ "TITLES.ADD_SITE" | translate }}</button>
                <button class="btn btn-primary" type="button" (click)="editSite()" *ngIf="selectedEditSite">{{ "EDIT_SITE" | translate }}</button>
              </div>
            </form>
          </div>
        </section>
      </div>

      <!--Referenti cliente-->
      <div class="card" [ngClass]="active_table === 'referent' ? 'active' : ''">
        <div class="card-title px-2 mb-0 d-flex" (click)="changeTab('referent')">
          <div class="col-6 pl-0">
            <h4 class="mb-0">{{ "MENU.CUSTOMERS_REFERENCE" | translate }}</h4>
          </div>
          <div class="col-6" ngClass.sm="d-none" ngClass.md="d-none" *ngIf="active_table === 'referent' && referentList && referentList.length > 0">
            <h4 class="mb-0" *ngIf="!isEditModeReferent">{{ "ADD_REFERENT" | translate }}</h4>
            <h4 class="mb-0" *ngIf="isEditModeReferent">{{ "EDIT_REFERENT" | translate }}</h4>
          </div>
        </div>
        <section [ngClass]="active_table === 'referent' ? 'card-body' : ''" class="row" *ngIf="!addressesList || addressesList.length < 1">
          <div class="col-12">
            {{ "CREATE_A_SITE_OFFICE" | translate }}
          </div>
        </section>
        <section [ngClass]="active_table === 'referent' ? 'card-body' : ''" class="row" *ngIf="addressesList && addressesList.length > 0">
          <div class="col-lg-6 col-12 mt-lg-3 mt-xl-0" [ngClass.xl]="'border-right'" *ngIf="referentList && referentList.length > 0">
            <div class="d-flex border-bottom py-1">
              <div class="flex-basis-25 font-weight-bold">
                {{ "NAME" | translate }}
              </div>
              <div class="flex-basis-35 font-weight-bold" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                {{ "EMAIL" | translate }}
              </div>
              <div class="flex-basis-20 font-weight-bold" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                {{ "PHONE" | translate }}
              </div>
              <div class="flex-basis-20 font-weight-bold" *ngIf="!isEditModeReferent" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                {{ "ACTIONS" | translate }}
              </div>
            </div>
            <div *ngFor="let referent of referentList; let i = index" class="py-1 border-bottom d-lg-flex align-items-lg-center"
                 [ngClass]="selectedEditReferent && referent.id === selectedEditReferent.id ? 'bg-primary' : null"
            >
              <div class="flex-basis-25" [ngbTooltip]="('OFFICE_SITE' | translate) + ': ' + referent.addresses[0].label" [ngClass.sm]="'flex-basis-100'">
                {{ referent.complete_name }}
              </div>
              <div class="flex-basis-35" [ngClass.sm]="'flex-basis-100 my-1'">
                <a [ngClass]="selectedEditReferent && referent.id === selectedEditReferent.id ? 'text-dark' : null" href="mailto:{{ referent.email }}">
                  {{ referent.email }}
                </a>
              </div>
              <div class="flex-basis-20" [ngClass.sm]="'flex-basis-100'">
                <a [ngClass]="selectedEditReferent && referent.id === selectedEditReferent.id ? 'text-dark' : null" href="tel:{{ referent.phone }}">
                  {{ referent.phone }}
                </a>
              </div>
              <div class="flex-basis-20" *ngIf="!isEditModeReferent" [ngClass.sm]="'flex-basis-100 d-flex justify-content-end'" [ngClass.md]="'flex-basis-100 d-flex justify-content-end'">
                <button class="bg-transparent border-0 text-secondary pr-1" (click)="enterEditModeReferent(referent)" has_capability="edit_customer_referent">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteReferent(referent)" class="bg-transparent border-0 text-danger remove-item" has_capability="delete_customer_referent">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="{{ !referentList || referentList.length < 1 ? 'col-12' : 'col-lg-6 col-12' }}" has_capability="create_customer_referent">
            <form class="row" [formGroup]="formGroupReferent">
              <div class="col-12 my-1" ngClass.xl="d-none" ngClass.lg="d-none">
                <h4 class="mb-0" *ngIf="!isEditModeReferent">{{ "ADD_REFERENT" | translate }}</h4>
                <h4 class="mb-0" *ngIf="isEditModeReferent">{{ "EDIT_REFERENT" | translate }}</h4>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="label-add">{{ "OFFICE_SITE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  [formControlName]="'site'"
                  [readonly]="addressesList.length < 1"
                  id="label-add"
                  bindLabel="label"
                  bindValue="id"
                  class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [items]="addressesList"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                >
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls.site.errors?.required">{{ "ERRORS.FIELD_OFFICE_SITE" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="name-add">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="name-add" name="name-add" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" formControlName="firstname" />
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls.firstname.errors?.required">{{ "ERRORS.FIELD_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls?.firstname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls?.firstname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12">
                <label for="surname-add">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="surname-add" name="surname-add" class="form-control {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" formControlName="lastname" />
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls.lastname.errors?.required">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls?.lastname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls?.lastname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12">
                <label for="email-add">{{ "EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="email-add" name="email-add" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" formControlName="email" />
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls.email.errors?.required">{{ "ERRORS.INSERT_EMAIL" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls?.email?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12">
                <label for="phone-add">{{ "PHONE" | translate }}</label>
                <input type="text" id="phone-add" maxlength="15" name="phone-add" class="form-control {{ fieldHasErrors('phone') ? 'is-invalid' : '' }}" formControlName="phone" />
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls?.phone?.errors?.minlength">{{ "MIN" | translate }} 9 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroupReferent.controls?.phone?.errors?.maxlength">{{ "MAX" | translate }} 15 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="col-12 d-flex justify-content-end">
                <button class="btn btn-outline-primary mr-1" type="button" (click)="resetReferentForm()">{{ "ALERT.BTN_CANCEL" | translate }}</button>
                <button class="btn btn-primary" type="button" (click)="addReferent()" *ngIf="!isEditModeReferent">{{ "ADD_REFERENT" | translate }}</button>
                <button class="btn btn-primary" type="button" (click)="editReferent()" *ngIf="isEditModeReferent">{{ "EDIT_REFERENT" | translate }}</button>
              </div>
            </form>
          </div>
        </section>
      </div>

      <div class="d-flex justify-content-end">
        <button class="btn btn-primary text-primary" (click)="edit()" has_capability="edit_customer">{{ "SAVE" | translate }}</button>
      </div>
    </div>
  </div>
</div>
